import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import SliderWrapper from 'jd-library/SliderWrapper'
import { showVariantDetailsSlider, getVariantFlags, setVariantProductData, showMoreDetailsSlider, showSyncImagesModal, resetVariantData, syncImageUpload, validateVariants, validateVariantsService } from '../../../actions/variants';
import VariantProductList from './VariantProductList';
import styles from './variants.scss';
import FormSwitch from 'jd-library/FormSwitch';
import { getImagePath } from '../../../common/productImageUtils';
import UpgradeModal from 'jd-library/UpgradeModal';
import toastMessageActions from 'jd-library/toastMessageActions';
import { updateVideoInLibrary } from '../../../actions/videoLibrary';
import axios from 'axios';
import useOnScroll from 'jd-library/useOnScroll';
import withPortal from 'jd-library/withPortal';
import { isSafari } from '../../../utills';

const UpgradeModalWeb = withPortal(UpgradeModal);

const VariantDetails = (props) => {
    const {noOfVariants, colorPresent} = getVariantFlags(props.variantData);
    const imageIndex = useRef(null);
    const syncImagesRef = useRef(true);
    const [scrolled, setScroll] = useState(false);
    const [scrollEl, setScrollEl] = useState(null);
    const setProductArray = () => {
        let arr = []
        for(let i=0;i<noOfVariants;i++){
            arr.push({
                errors: {},
                warnings: {},
                isAutoReorderLevel: true,
                isAutoReorderQuantity: true,
                expiryBy: 'manufacturingDate',
                imageUrlArr: [],
                videoUrlArr: [],
                bestBeforeUnit: 'months',
                showOnWebsite: true,
                ...(props.variantProductData ? props.variantProductData[i] : {}),
            })
        }
        for(let i=0;i<arr.length;i+=1){
            if(colorPresent && props.syncImages && arr[i]?.imageUrlArr?.length){
                arr = syncImageUpload(arr, props.variantCombinations, i)
            }
        }
        return arr;
    }

    const [modalData, setModalData] = useState({show: false, modal: 'upgrade'})
    const [productData, setProductData] = useState(setProductArray());

    useEffect(()=>{
        if(props.syncImages && !syncImagesRef.current){
            let temp = productData.map((item)=>({
                ...item,
                imageUrlArr: []
            }))
            setProductData(temp);
        }
        syncImagesRef.current = props.syncImages;
    }, [props.syncImages])

    const modalProps = {
        upgrade: {
            imageUrl: 'https://image1.jdomni.in/jdomni_email/premiumPackageImg.png',
            title: 'Upgrade to Premium to Add Product Variants',
            subtext: 'Create multiple variants to a product that comes in more than one options such as size, color, etc. Upgrade now to save your changes.',
            btnProps: {
                text: 'Upgrade Now',
                onClick: ()=>{
                    if(props.deviceData.isIosApp){
                        window.location.href = '/myaccount/jd-vendor/upgradeios';
                    }else{
                        sendUpgradeReq();
                    }
                }
            },
            onHidden: ()=>setModalData({show: false})
        },
        ['request-sent']: {
            imageUrl: 'https://image1.jdomni.in/jdomni_email/check_mark_1812041558.gif',
            title: 'Upgrade Request Sent Successfully',
            subtext: 'Thank you '+props.permissions.ownerName+"! You've taken the first steps towards owning a software your business would love. Our sales executive would get in touch with you shortly",
            btnProps: {
                text: 'Close',
                onClick: ()=>{
                    window.history.back();
                }
            },
            onHidden: ()=>{
                window.history.back();
                window.history.back();
                props.resetVariantData();
            }
        }
    }

    const sendUpgradeReq = () => {
        const ownerName = props.permissions.ownerName ? props.permissions.ownerName.split(' ') : [];
        let deviceKey = ''
        if(props.deviceData.isAndroidApp){
            deviceKey = 'Android'
        }else if(props.deviceData.isIpad || props.deviceData.isIpadApp){
            deviceKey = 'Ipad'
        }else if(props.deviceData.isMobile){
            deviceKey = 'Mobile'
        }else{
            deviceKey = 'Web'
        }
        const upgradeData = {
            "parameters": {
                "currentPacakageId": props.permissions.packageId,
                "upgradePackageId": props.permissions.packagePermissionData.packageDetails?.Package_Info?.UpgradeToPackageIds?.[0] || '',
                "storeName": props.permissions.storeName || '',
                "firstName": ownerName[0] || '',
                "lastName": ownerName[1] || '',
                "mobileNumber": props.permissions.ownerMobileNumber || '',
                "emailId": props.permissions.ownerEmail || '',
                "module": "Products.Add_Variants",
                "sourceDevice": deviceKey
            }
        }; 
        axios.post('/marketplace/upgradeSupportRequest.ns', upgradeData)
        .then(()=>{
            setModalData({
                show: true,
                modal: 'request-sent'
            })
        })
    }

    const uploadImage = (res) => {
        //#TO_DO - Make Single Function
        let temp = [...productData]
        let saveData = true;
        if(res.forVideo){
            if(res.initialReq){
                temp[imageIndex.current].videoUrlArr.push(res.imageUrl);
                props.updateVideoInLibrary({...res.imageUrl, isVariantProduct: true}) //Add the Video to the Library
            }else{
                if(!res.imageUrl.videoId){
                    //Generate the Video ID for uploaded videos
                    saveData = false;
                    props.updateVideoInLibrary({...res.imageUrl, variantId: "", isVariantProduct: true, cb: (id)=>{
                        temp[imageIndex.current].videoUrlArr[0] = ({...res.imageUrl, uploaded: true, videoId: id});
                        if(colorPresent && props.syncImages){
                            temp = syncImageUpload(temp, props.variantCombinations, imageIndex.current)
                        }
                        setProductData(temp);
                    }})
                }else{
                    temp[imageIndex.current].videoUrlArr[0] = ({...res.imageUrl, uploaded: true})
                }
            }
            if(colorPresent && props.syncImages){
                temp = syncImageUpload(temp, props.variantCombinations, imageIndex.current)
            }
        }else{
            let toastMsg = ''
            if(res.createdfrom == 'url'){
                res.imageUrl = {
                    uploaded: true,
                    imgURL: res.imgURL,
                    actualPath: getImagePath(res.imgURL)
                }
                temp[imageIndex.current].imageUrlArr.push(res.imageUrl)
            }else if(res.createdfrom == 'photoGallery' || res.createdfrom == 'copyImages'){
                temp[imageIndex.current].imageUrlArr.push(...res.imageUrlArr)
                toastMsg = res.createdfrom == 'copyImages' ? '' : toastMsg
            }else if(res.imageUrl.uploaded){
                for(let i=0;i<temp[imageIndex.current].imageUrlArr.length;i++){
                    if(temp[imageIndex.current].imageUrlArr[i].imgIndex == res.imgIndex){
                        temp[imageIndex.current].imageUrlArr[i] = res.imageUrl
                    }
                }
            }else{
                toastMsg = '';
                temp[imageIndex.current].imageUrlArr.push(res.imageUrl)
            }
            if(colorPresent && props.syncImages){
                temp = syncImageUpload(temp, props.variantCombinations, imageIndex.current)
            }
            if(toastMsg){
                props.showToastMessage({
                    showToastMessage: true,
                    message: toastMsg,
                    type: 'info',
                    duration: 5000
                });
            }
        }
        saveData && setProductData(temp);
        return temp[imageIndex.current];
    }

    const uploadOptionProps = {
        type: props.uploadOptions.type,
        onFileUpload: res=>uploadImage(res),
        onHidden: ()=>{},
        vendorSubMenu: true,
        isVariant: true,
        variantProductData: productData,
        variantIndex: imageIndex.current,
        containerInfo: props.uploadOptions.containerInfo,
        style: props.uploadOptions.style,
        data:{
            imageUrlArr: productData[imageIndex.current]?.imageUrlArr
        },
        fromVideoListing: props.uploadOptions.fromVideoListing
    }

    const duplicateSku = () => {
        let skuArr = [];
        productData.forEach(item=>{
            if(item.sku){
                skuArr.push(item.sku);
            }
        });
        skuArr = skuArr.filter((sku,index)=>skuArr.indexOf(sku)!=index);
        if(skuArr.length){
            props.showToastMessage({
                showToastMessage: true,
                message: 'Duplicate SKU',
                type: 'error',
                duration: 5000
            });
            return true;
        }
        return false;
    }
    useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            setScroll(true);
          }else{
             setScroll(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })

    return(
        <>
            <SliderWrapper
                header={{
                    heading: props.isEdit ? 'Edit Variant Details' : 'Add Variant Details',
                    raised: scrolled,
                    rightIcons: []
                }}
                onHidden={()=>{
                    props.showVariantDetailsSlider(false);
                }}
                slider={{
                    className: `${styles['variant-slider']} ${styles['details-slider']}`
                }}
                footer={{
                    btnProps: [{
                        children: 'Save',
                        clickHandler: () => {
                            let {errorMsg,variants} = props.isService ? props.validateVariantsService(productData) : props.validateVariants(productData);
                            if(errorMsg) {
                                setProductData(variants)
                                props.showToastMessage({
                                    message: errorMsg,
                                    type: 'info'
                                })
                                return;
                            }

                            props.setVariantProductData(productData.map(cur => {
                                cur.errors={};
                                return cur;
                            }));
                            window.history.back();
                            window.history.back();
                            let safari = isSafari();
                            if((!props.deviceData.isChrome && safari) || props.deviceData.isIphoneApp) {
                                setTimeout(() => {
                                    window.history.back();
                                }, 0);
                            }
                            // if(!props.isEdit) {
                            //     window.history.back();
                            // }
                        }
                    }]
                }}
                updateScrollContRef={(scrollref) => {
                    setScrollEl(scrollref)
                }}
            >
                <div className={styles['slider-body']}>
                    {/* {(colorPresent && !props.isEdit) && <div className={styles['sync-images'] + " " + styles['details-slider']}>
                        Sync Images for same coloured variants
                        <div>
                            <FormSwitch
                                checked={props.syncImages}
                                onClick={() => {
                                    props.showSyncImagesModal(true)
                                }}
                                variant='secondary'
                            />
                        </div>
                    </div>} */}
                    <VariantProductList 
                        productData={productData}
                        setMoreDetails={(index, value, titleStr)=>{
                            props.showMoreDetailsSlider({
                                show: true,
                                index: index,
                                productData: value,
                                allProductData: productData,
                                titleStr: titleStr,
                                onSave: (data, index)=>{
                                    let temp = [...productData]
                                    temp[index] = data;
                                    if(colorPresent && props.syncImages){
                                        temp = syncImageUpload(temp, props.variantCombinations, index)
                                    }
                                    setProductData(temp);
                                }
                            })
                        }}
                        setAllProductData={setProductData}
                        setProductData={(obj,index)=>{
                            let temp = [...productData]
                            if(JSON.stringify(temp[index]) != JSON.stringify(obj)) {
                                obj['isChanged'] = true;
                            }
                            temp[index] = obj;
                            if(colorPresent && props.syncImages){
                                temp = syncImageUpload(temp, props.variantCombinations, index)
                            }
                            setProductData(temp);
                        }}
                        variantCombinations={props.variantCombinations}
                        setImageIndex={(index)=>{imageIndex.current = index}}
                        uploadOptionProps={uploadOptionProps}
                        showUploadOptions={props.uploadOptions.sliderType == 'upload'}
                        showToastMessage={props.showToastMessage}
                        permissions={props.permissions}
                    />
                </div>
                {modalData.show && 
                    (props.deviceData.isMobile ? 
                        <UpgradeModal {...modalProps[modalData.modal]}/> :
                        <UpgradeModalWeb {...modalProps[modalData.modal]} />
                    )
                }
            </SliderWrapper>
        </>
    )
}

const mapStateToProps = (state,props) => {
    return{
        ...props,
        variantData: state.variants.variantData,
        variantCombinations: state.variants.variantCombinations,
        variantProductData: state.variants.variantProductData,
        syncImages: state.variants.syncImages,
        uploadOptions: state.uploadOptions,
        allowVariant: state.permissions?.packagePermissionData?.packageDetails?.Products?.Add_Variants?.status == 'VISIBLE',
        isEdit: state.variants.variantDetailsSlider?.mode == 'edit',
        permissions: state.permissions,
        deviceData: state.deviceData,
        isService: state.products.editProduct.categoryType == 'service'
    }
}

export default connect(mapStateToProps,{
    showVariantDetailsSlider,
    setVariantProductData,
    showMoreDetailsSlider,
    showSyncImagesModal,
    resetVariantData,
    updateVideoInLibrary,
    showToastMessage: toastMessageActions.showMessage,
    validateVariants,
    validateVariantsService
})(VariantDetails)